<template>
    <section class="page-attention">
        <div class="row-space-tbf">
            <div class="space-left"></div>
            
            <not-paid v-if="$auth.check() && (!$auth.user().instance || ['new', 'unpaid'].includes($auth.user().rights.instance))"/>
            <not-found v-else/>

            <div class="space-right"></div>
        </div>
    </section>
</template>

<script>
    import NotFound from '../General/NotFound'
    import NotPaid from '../General/NotPaid'

    export default {
        data(){
            return{
            }
        },
        mounted(){

        },
        components: {
            NotFound,
            NotPaid
        },
        methods: {
            handleAnimationLogo(anim){
                this.anim_logo = anim;
                this.anim_logo.setSpeed(1);
            }
        }
    }
</script>